var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComprehensiveTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.887 64.1298H36.5001V61.7745H5.887C3.93627 61.7745 2.35474 60.1929 2.35474 58.2422V6.43558C2.35474 4.48427 3.93627 2.90332 5.887 2.90332H57.6936C59.6452 2.90332 61.2259 4.48427 61.2259 6.43558V33.5161H63.5812V6.43558C63.5774 3.18575 60.9437 0.55242 57.6936 0.548584H5.887C2.63776 0.55242 0.00413164 3.18575 0 6.43558V58.2422C0.00413164 61.492 2.63776 64.1254 5.887 64.1298Z",
    fill: "#FE8839"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70996 5.25854H7.0644V7.61299H4.70996V5.25854Z",
    fill: "#FE8839"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41992 5.25854H11.7753V7.61299H9.41992V5.25854Z",
    fill: "#FE8839"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1289 5.25854H16.4839V7.61299H14.1289V5.25854Z",
    fill: "#FE8839"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70996 9.96777H58.871V12.3231H4.70996V9.96777Z",
    fill: "#FE8839"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8283 15.0227L13.8376 18.0134C11.3096 16.3398 7.92435 16.8533 6.0058 19.2013C4.08754 21.5489 4.25959 24.9687 6.40332 27.1122C8.54675 29.2565 11.9669 29.4285 14.3148 27.51C16.6625 25.5917 17.1763 22.2059 15.5024 19.6785L18.4928 16.6878L16.8283 15.0227ZM10.5958 26.4517C8.64532 26.4517 7.06379 24.8705 7.06379 22.9197C7.06379 20.9687 8.64532 19.3878 10.5958 19.3878C11.1211 19.3896 11.6378 19.51 12.1091 19.7404L9.76382 22.086L11.4283 23.7511L13.7753 21.407C14.0058 21.878 14.1265 22.3947 14.1283 22.9197C14.1283 24.8705 12.5474 26.4517 10.5958 26.4517Z",
    fill: "#FE8839"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0166 19.3877H40.0323V21.7421H20.0166V19.3877Z",
    fill: "#FE8839"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0166 24.0972H28.2583V26.4516H20.0166V24.0972Z",
    fill: "#FE8839"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6123 24.0972H47.0958V26.4516H30.6123V24.0972Z",
    fill: "#FE8839"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3867 19.3877H54.161V21.7421H42.3867V19.3877Z",
    fill: "#FE8839"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8283 29.1516L13.8376 32.1423C11.3096 30.4687 7.92435 30.9822 6.0058 33.3302C4.08754 35.6781 4.25959 39.0976 6.40332 41.2417C8.54675 43.3854 11.9669 43.5575 14.3148 41.6389C16.6625 39.7203 17.1763 36.3356 15.5024 33.8074L18.4928 30.8167L16.8283 29.1516ZM10.5958 40.5809C8.64532 40.5809 7.06379 38.9994 7.06379 37.0486C7.06379 35.0976 8.64532 33.5161 10.5958 33.5161C11.1211 33.5182 11.6378 33.6389 12.1091 33.8694L9.76382 36.2155L11.4283 37.88L13.7753 35.5356C14.0058 36.0069 14.1265 36.5236 14.1283 37.0486C14.1283 38.9994 12.5474 40.5809 10.5958 40.5809Z",
    fill: "#FE8839"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0166 33.5161H40.0323V35.8711H20.0166V33.5161Z",
    fill: "#FE8839"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0166 38.2262H28.2583V40.5809H20.0166V38.2262Z",
    fill: "#FE8839"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6123 38.2262H40.0313V40.5809H30.6123V38.2262Z",
    fill: "#FE8839"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3867 33.5161H47.0962V35.8711H42.3867V33.5161Z",
    fill: "#FE8839"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8283 43.2806L13.8376 46.2714C11.3096 44.5977 7.92435 45.1113 6.0058 47.4592C4.08754 49.8072 4.25959 53.2267 6.40332 55.3707C8.54675 57.5147 11.9669 57.6862 14.3148 55.7679C16.6625 53.8494 17.1763 50.4644 15.5024 47.9361L18.4928 44.9457L16.8283 43.2806ZM10.5958 54.7099C8.64532 54.7099 7.06379 53.1284 7.06379 51.1777C7.06379 49.2267 8.64532 47.6454 10.5958 47.6454C11.1211 47.6472 11.6378 47.7676 12.1091 47.9984L9.76382 50.3446L11.4283 52.009L13.7753 49.6646C14.0058 50.1359 14.1265 50.653 14.1283 51.1777C14.1283 53.1284 12.5474 54.7099 10.5958 54.7099Z",
    fill: "#FE8839"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0166 47.6454H35.3228V50.0007H20.0166V47.6454Z",
    fill: "#FE8839"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0166 52.3551H28.2583V54.7098H20.0166V52.3551Z",
    fill: "#FE8839"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6123 52.3551H35.3218V54.7098H30.6123V52.3551Z",
    fill: "#FE8839"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3393 71.1942C65.0938 71.1942 73.0003 63.2863 73.0003 53.5327C73.0003 43.7782 65.0938 35.8711 55.3393 35.8711C45.5848 35.8711 37.6777 43.7782 37.6777 53.5327C37.6892 63.2819 45.5895 71.1824 55.3393 71.1942ZM55.3393 38.2261C63.7923 38.2261 70.6459 45.079 70.6459 53.5327C70.6459 61.9863 63.7923 68.8389 55.3393 68.8389C46.8854 68.8389 40.0322 61.9863 40.0322 53.5327C40.0422 45.0832 46.8892 38.2356 55.3393 38.2261Z",
    fill: "#FE8839"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1566 54.1834L46.0488 55.2358L48.4039 59.9456C48.5727 60.2844 48.8949 60.5213 49.2689 60.5818C49.3296 60.5913 49.3904 60.5963 49.4515 60.5972C49.7635 60.5972 50.063 60.473 50.2843 60.2522L64.4128 46.1232L62.7483 44.4581L49.7738 57.4321L48.1566 54.1834Z",
    fill: "#FE8839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComprehensiveTesting);
export default __webpack_public_path__ + "static/media/ComprehensiveTesting.2df11ceedf1eee179efec81916d60869.svg";
export { ForwardRef as ReactComponent };